componentRegistryInstance.register('radio', 'edit', 'hrd.components.form.RadioComponent');

hrd.components.form.RadioComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.RadioComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},

	enhanceEditField: function(field, id, klass) {
		this._super(field, id, ''); // used to remove the class
		field.removeAttr('name'); // removed otherwise buttonset does not work
		field.addClass('choice-group');
		let appearance = field.data('appearance') || 'buttonset';
		const radioTemplate = field.data('template');
		const buttons = field.data('buttons');
		const isButtonEmpty = field.data('buttonEmpty');

		if (appearance === 'radio') {
			// need to add 'skip-layout' class because it can generate wrong widths during 'resize'
			let $composite = field.closest('.field-composite');
			$composite.addClass('skip-layout');
		}

		field.children('input').each((i, input) => {
			var $input = $(input);
			var newId = `${id}-${i}`;
			$input
				.attr('data-ignore', true)
				.attr('id', newId)
				.attr('name', `${id}-group`); // metto id del padre come parte del nome del gruppo
			var $label = $input.next();
			$label.prop('for', newId);
			//
			if (appearance === 'radio') {
				var $cnt = $(`<div class="choice-group-item"></div>`);
				$input.addClass('ignore-for-fhs choice-group-item-field').attr('data-type', 'choice-group-item');
				$label.addClass('ignore-aw');
				$cnt.append($input.detach()).append($label.detach()).appendTo(field);
				
				if (radioTemplate) {
					const $customInputContainer = $(`<div class="input-container ${radioTemplate}"></div>`);
					const $customInput = $(`<div class="radio"></div>`);

					$customInputContainer.append($input.detach()).append($customInput).prependTo($cnt);

					$customInput.off('.custom-input').on('click.custom-input', () => {
						$input.trigger('click');
					});
				}
			}
		});
		if (appearance === 'buttonset') {
			field.buttonset();
		} else if (appearance === 'radio') {
			if (buttons && buttons.length > 0) {
				const $buttons = $('<div class="buttons"></div>');

				buttons.forEach((buttonData) => {
					const buttonAction = buttonData.action || '';
					const buttonLabel = buttonData.label || '';
					const $button = $(`<button type="button" data-action="${buttonAction}">${buttonLabel}</button>`);

					$buttons.append($button);
				});

				field.addClass('with-buttons');
				field.append($buttons);
			}
			if (isButtonEmpty) {
				let $buttons = $('.buttons', field);
				const $button = $(`
					<button type="button" data-action="" data-icon-primary="f-icon fas fa-trash-alt" data-show-text="false">
						${xlate('common.form.radio.empty.btn')}
					</button>
				`);

				if ($buttons.exists()) {
					$buttons.append($button);
				} else {
					$buttons = $('<div class="buttons"></div>');
					field.append($buttons.append($button));
				}

				field.addClass('with-buttons');
				$button.on('click', (event) => {
					const $groupItems = $('input', field);
					$groupItems.prop('checked', false);
					this.decorateField(field, this.formInstanceToObject());
				});
			}
		}
	},
	getEditableField: function(field, name, object, options) {
		var checkedRadio = $(':radio:checked', field);
		if (checkedRadio.exists()) {
			this.setValueByPath(object, name, checkedRadio.val());
		} else {
			// needed to empty the radio group
			this.setValueByPath(object, name, undefined);
		}
	},
	setEditableField: function(field, value, object, options) {
		let appearance = field.data('appearance') || 'buttonset';
		let radioToCheck = $(`input[value="${value}"]`, field);
		radioToCheck.prop("checked", true);
		if (appearance === 'buttonset') {
			radioToCheck.button("refresh");
		}
	},
	initalizeComponent: function(field, initialValue) {
		let appearance = field.data('appearance') || 'buttonset';
		let radioToCheck = $(`input[value="${initialValue}"]`, field);
		radioToCheck.prop("checked", true);
		if (appearance === 'buttonset') {
			radioToCheck.button("refresh");
		}
	},
	resetEditableField: function(field, options) {
		let appearance = field.data('appearance') || 'buttonset';
		let radioToUnCheck = $('input', field);
		radioToUnCheck.prop("checked", false);
		if (appearance === 'buttonset') {
			radioToUnCheck.button("refresh");
		}
	},
	disableField: function(field, disable) {
		let appearance = field.data('appearance') || 'buttonset';
		if (appearance === 'buttonset') {
			field.buttonset('option', 'disabled', disable);
		}
	}
});